import React from "react";

import { Button, EmptyState, NotificationSnackbar, SectionCard } from "shared/ui";

import { DeleteModifierSetDialog } from "features/ModifierSets/components/DeleteModifierSetDialog";
import { ModifierSetDialog } from "features/ModifierSets/components/ModifierSetDialog";
import { ModifierSetsList } from "features/ModifierSets/components/ModifierSetsList";
import { ModifierSetsContext } from "features/ModifierSets/context";
import { useModifierSetsState } from "features/ModifierSets/hooks/useModifierSetsState";

import { Container } from "./styles";

interface ModifierSetsProps {
    // Набор из адреса страницы — открываем его диалог сразу.
    initialModifierSetId?: number;
}

export const ModifierSets = ({ initialModifierSetId }: ModifierSetsProps) => {
    const state = useModifierSetsState(initialModifierSetId);

    if (state.loading) {
        return <Container>Загрузка наборов…</Container>;
    }

    if (state.error) {
        return <Container>Не удалось загрузить наборы модификаторов</Container>;
    }

    return (
        <ModifierSetsContext.Provider value={state}>
            <Container>
                <SectionCard
                    title="Наборы модификаторов"
                    description="Размеры, добавки и комбо. Набор создаётся один раз и подключается к любым позициям меню"
                    headerRight={
                        <Button onClick={state.openCreateDialog}>Добавить набор</Button>
                    }
                >
                    {state.modifierSets.length === 0 ? (
                        <EmptyState
                            title="Наборов пока нет"
                            description="Наборы позволяют гостю выбрать размер напитка, добавки к блюду или состав комбо. Создайте первый — и подключите его к позициям."
                            action={<Button onClick={state.openCreateDialog}>Добавить набор</Button>}
                        />
                    ) : (
                        <ModifierSetsList />
                    )}
                </SectionCard>

                <ModifierSetDialog
                    open={state.isSetDialogOpen}
                    modifierSet={state.editedModifierSet}
                    locale={state.locale}
                    availableLanguages={state.availableLanguages}
                    currencyFormatter={state.currencyFormatter}
                    saving={state.saving}
                    onClose={state.closeSetDialog}
                    onSubmit={state.submitModifierSet}
                />
                <DeleteModifierSetDialog />

                <NotificationSnackbar {...state.notify.snackbarProps} />
            </Container>
        </ModifierSetsContext.Provider>
    );
};
